import * as React from 'react';

import ActionButton from 'components/buttons/action-button/ActionButton';
import YouTubePlayer from 'components/youtube-player/YouTubePlayer';
import { withModal } from 'components/modal/ModalHOC';

import SOVQueriesModal from 'modules/insights/sov/components/queries/modals/SOVQueriesModal';
import SOVCallout from 'modules/insights/sov/components/callouts/SOVCallout';

import { __t, applyTranslations } from 'utils/language';
import { COLLABARY, CREATE, FIXED_TO_TOP, QUERY } from 'modules/insights/sov/utils/sov';

import './sov-callout-freemium.scss';

import type {
  SOVGeneralProps,
  SOVQuerySave,
  SOVReport,
  SOVReportType
} from 'modules/insights/sov/types';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('./sov-callout-freemium.i18n.json'));

type Props = {
  report: SOVReport,
  reportType: SOVReportType,
  onSaveQuery: (a: SOVQuerySave) => void
};

const COLLABARY_MSG_KEY = 'collabary_common';
const MSG_KEY = 'sov_callout_freemium';

const ActionButtonWithQueriesModal = withModal(ActionButton, {
  modalContent: SOVQueriesModal,
  width: 'small',
  positionOverride: FIXED_TO_TOP
});

class SOVCalloutFreemium extends React.PureComponent<Props> {
  getText(): SOVGeneralProps {
    const { reportType } = this.props;

    return {
      header: __t(`${MSG_KEY}.header`, {
        reportType: __t(`${COLLABARY_MSG_KEY}.social.${reportType}`)
      }),
      bulletOne: __t(`${MSG_KEY}.bullet_one`),
      bulletTwo: __t(`${MSG_KEY}.bullet_two`),
      button: __t(`${MSG_KEY}.button`)
    };
  }

  renderVideo(): React.ReactNode {
    return (
      <div className="sov-callout-freemium__video">
        <YouTubePlayer
          name="sov-callout-freemium__video"
          videoId="ZSUhX3psN04"
          width={416}
          height={234}
        />
      </div>
    );
  }

  renderButton(buttonText: string): React.ReactNode {
    const { report, onSaveQuery } = this.props;

    return (
      <ActionButtonWithQueriesModal
        color="primary"
        className="sov-callout-freemium__button"
        modalContentProps={{
          report,
          query: {},
          pageType: COLLABARY,
          sectionType: QUERY,
          actionType: CREATE,
          onSaveQuery
        }}
      >
        {buttonText}
      </ActionButtonWithQueriesModal>
    );
  }

  render(): React.ReactNode {
    const text = this.getText();

    return (
      <SOVCallout
        headerText={text.header}
        bulletItems={[text.bulletOne, text.bulletTwo]}
        content={this.renderVideo()}
        button={this.renderButton(text.button)}
        className="sov-callout-freemium"
      />
    );
  }
}

export default SOVCalloutFreemium;
